import { render, staticRenderFns } from "./AcraFeedback.vue?vue&type=template&id=3f849dae&scoped=true&"
import script from "./AcraFeedback.vue?vue&type=script&lang=js&"
export * from "./AcraFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AcraFeedback.vue?vue&type=style&index=0&id=3f849dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f849dae",
  null
  
)

export default component.exports